import { getStore } from '../store/store';
/**
 * User is in search mode (thus in a search session) when searchSessionGuid
 * is non-null.
 */
export default function isInSearchMode() {
    return !!getStore().searchSessionGuid;
}
//# sourceMappingURL=isInSearchMode.js.map